import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _76c00eea = () => interopDefault(import('../pages/vacancies/index.vue' /* webpackChunkName: "pages/vacancies/index" */))
const _5bce20f6 = () => interopDefault(import('../pages/cargo-landing/_.vue' /* webpackChunkName: "" */))
const _bab88a30 = () => interopDefault(import('../pages/transport/_.vue' /* webpackChunkName: "pages/transport/_" */))
const _58cf5d4a = () => interopDefault(import('../pages/transport/index.vue' /* webpackChunkName: "pages/transport/index" */))
const _68113036 = () => interopDefault(import('../pages/tip-gruza/_/products.vue' /* webpackChunkName: "pages/tip-gruza/_/products" */))
const _ceac45be = () => interopDefault(import('../pages/tip-gruza/_/index.vue' /* webpackChunkName: "pages/tip-gruza/_/index" */))
const _990a9ede = () => interopDefault(import('../pages/tip-gruza/index.vue' /* webpackChunkName: "pages/tip-gruza/index" */))
const _4d403ffc = () => interopDefault(import('../pages/sets/_.vue' /* webpackChunkName: "pages/sets/_" */))
const _21b7bfcc = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _790e8249 = () => interopDefault(import('../pages/routes/_cityfrom/_cityto/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/_cityto/index" */))
const _6f465293 = () => interopDefault(import('../pages/routes/_cityfrom/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/index" */))
const _8b6e6224 = () => interopDefault(import('../pages/routes/index.vue' /* webpackChunkName: "pages/routes/index" */))
const _65a73019 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _efc94ef0 = () => interopDefault(import('../pages/otrasli/_/products.vue' /* webpackChunkName: "pages/otrasli/_/products" */))
const _33053144 = () => interopDefault(import('../pages/otrasli/_/index.vue' /* webpackChunkName: "pages/otrasli/_/index" */))
const _4435a60e = () => interopDefault(import('../pages/otrasli/index.vue' /* webpackChunkName: "pages/otrasli/index" */))
const _0331b82f = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _04e85977 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _c69e993a = () => interopDefault(import('../pages/lk/index.vue' /* webpackChunkName: "pages/lk/index" */))
const _19819581 = () => interopDefault(import('../pages/gruzopodemnost/_.vue' /* webpackChunkName: "pages/gruzopodemnost/_" */))
const _c7359118 = () => interopDefault(import('../pages/gruzopodemnost/index.vue' /* webpackChunkName: "pages/gruzopodemnost/index" */))
const _77a3c0b5 = () => interopDefault(import('../pages/events/_slug.vue' /* webpackChunkName: "pages/events/_slug" */))
const _795a61fd = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _8c6097c6 = () => interopDefault(import('../pages/distillation/_id/_vin.vue' /* webpackChunkName: "pages/distillation/_id/_vin" */))
const _103de13e = () => interopDefault(import('../pages/distillation/_id/index.vue' /* webpackChunkName: "pages/distillation/_id/index" */))
const _31f09f76 = () => interopDefault(import('../pages/distillation/index.vue' /* webpackChunkName: "pages/distillation/index" */))
const _160f7770 = () => interopDefault(import('../pages/cargo-rate-calculator/index.vue' /* webpackChunkName: "pages/cargo-rate-calculator/index" */))
const _41077699 = () => interopDefault(import('../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _42be17e1 = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _12c4d20e = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/vacancies",
    component: _76c00eea,
    name: "vacancies"
  }, {
    path: "/ural/:slug",
    components: {
      default: _5bce20f6
    }
  }, {
    path: "/transport/*",
    component: _bab88a30,
    name: "transport-all"
  }, {
    path: "/transport",
    component: _58cf5d4a,
    name: "transport"
  }, {
    path: "/tip-gruza/*/products",
    component: _68113036,
    name: "tip-gruza-all-products"
  }, {
    path: "/tip-gruza/*",
    component: _ceac45be,
    name: "tip-gruza-all"
  }, {
    path: "/tip-gruza",
    component: _990a9ede,
    name: "tip-gruza"
  }, {
    path: "/sets/*",
    component: _4d403ffc,
    name: "sets-all"
  }, {
    path: "/search",
    component: _21b7bfcc,
    name: "search"
  }, {
    path: "/routes/:cityfrom/:cityto",
    component: _790e8249,
    name: "routes-cityfrom-cityto"
  }, {
    path: "/routes/:cityfrom",
    component: _6f465293,
    name: "routes-cityfrom"
  }, {
    path: "/routes",
    component: _8b6e6224,
    name: "routes"
  }, {
    path: "/product/:slug?",
    component: _65a73019,
    name: "product-slug"
  }, {
    path: "/otrasli/*/products",
    component: _efc94ef0,
    name: "otrasli-all-products"
  }, {
    path: "/otrasli/*",
    component: _33053144,
    name: "otrasli-all"
  }, {
    path: "/otrasli",
    component: _4435a60e,
    name: "otrasli"
  }, {
    path: "/news/:slug",
    component: _0331b82f,
    name: "news-slug"
  }, {
    path: "/news",
    component: _04e85977,
    name: "news"
  }, {
    path: "/lk",
    component: _c69e993a,
    name: "lk"
  }, {
    path: "/gruzopodemnost/*",
    component: _19819581,
    name: "gruzopodemnost-all"
  }, {
    path: "/gruzopodemnost",
    component: _c7359118,
    name: "gruzopodemnost"
  }, {
    path: "/events/:slug",
    component: _77a3c0b5,
    name: "events-slug"
  }, {
    path: "/events",
    component: _795a61fd,
    name: "events"
  }, {
    path: "/distillation/:id/:vin",
    component: _8c6097c6,
    name: "distillation-id-vin"
  }, {
    path: "/distillation/:id",
    component: _103de13e,
    name: "distillation-id"
  }, {
    path: "/distillation",
    component: _31f09f76,
    name: "distillation"
  }, {
    path: "/cargo-rate-calculator",
    component: _160f7770,
    name: "cargo-rate-calculator"
  }, {
    path: "/cargo-landing/*",
    component: _5bce20f6,
    name: "cargo-landing-all"
  }, {
    path: "/articles/:slug",
    component: _41077699,
    name: "articles-slug"
  }, {
    path: "/articles",
    component: _42be17e1,
    name: "articles"
  }, {
    path: "/*",
    component: _12c4d20e,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
